import React, { Component } from "react";
import axios from "axios";
import MetaTags from "react-meta-tags";
import { BsCardChecklist, BsCreditCard, BsPrinter } from "react-icons/bs";
import { AiOutlineFileSearch } from "react-icons/ai";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import Swal from "sweetalert2";
import { mua } from "./MUA";
import { admission } from "./ADMISSION";
import "./Checkregister.css";

export default class Checkregister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 1,
      citizent: "",
      titlename: "",
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    localStorage.clear();
    this.setState({ titlename: "ตรวจสอบสถานะ" });
  }

  handleChange(event) {
    event.preventDefault();
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const citizent = this.state.citizent.replace("/", ",");
    this.setState({ citizent, loading: true });

    axios
      .get(mua + "/admissionnew2022/showlistregister?id=" + citizent)
      .then((res) => {
        const studentok = res.data.data.data.filter(
          ({ ROB_ID, Major1_MAJOR_ID, REGISTER_STATUS }) =>
            !(ROB_ID === "91" && Major1_MAJOR_ID === "1104" && REGISTER_STATUS === "11")
        );
        if (studentok.length !== 0) {
          if (studentok.length !== 0) {
            console.log(studentok);
            let rob = "";
            studentok.forEach((element) => {
              if (element.ROB_ID === "131") {
                rob = "131";
              }
            });
            if (rob !== "131x") {
              Swal.fire({
                icon: "success",
                title: "ยินดีต้อนรับ",
                timer: 1500,
                timerProgressBar: true,
                showConfirmButton: false,
              }).then((res) => {
                localStorage.setItem("citizent", citizent);
                localStorage.setItem("statustitle", this.state.titlename);
                localStorage.setItem("ID_LOGIN", studentok[0]["ID_LOGIN"]);
                axios
                  .get(mua + "/admissionnew2022/showcheckmember/" + citizent)
                  .then((tokenRes) => {
                    const auth = tokenRes?.data?.data?.auth;
                    if (auth) localStorage.setItem("token", auth);
                  })
                  .catch(() => {})
                  .then(() => {
                this.setState({ status: studentok.length });
                if (
                  studentok[0]["REGISTER_STATUS"] === "0" ||
                  studentok[0]["REGISTER_STATUS"] === "1" ||
                  studentok[0]["REGISTER_STATUS"] === "2" ||
                  studentok[0]["REGISTER_STATUS"] === "3" ||
                  studentok[0]["REGISTER_STATUS"] === "4" ||
                  studentok[0]["REGISTER_STATUS"] === "41" ||
                  studentok[0]["REGISTER_STATUS"] === "5" ||
                  studentok[0]["REGISTER_STATUS"] === "11" ||
                  studentok[0]["REGISTER_STATUS"] === "12" ||
                  studentok[0]["REGISTER_STATUS"] === "91"
                ) {
                  window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
                } else if (
                  studentok[0]["REGISTER_STATUS"] === "6" ||
                  studentok[0]["REGISTER_STATUS"] === "7" ||
                  studentok[0]["REGISTER_STATUS"] === "8" ||
                  studentok[0]["REGISTER_STATUS"] === "9"
                ) {
                  if (studentok[0]["ROB_ID"] === "126") {
                    window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
                  } else if (studentok[0]["ROB_ID"] !== "88") {
                    axios
                      .get(admission + "/student/creckprecent1/" + studentok[0]["REGISTER_ID"])
                      .then((response) => {
                        if (response.data === 0) {
                          window.location.href = `${
                            process.env.REACT_APP_BASENAME || ""
                          }/Dataregister`;
                        } else {
                          localStorage.setItem("statusHeader", "1");
                          if (studentok[0]["ROB_ID"] === "141") {
                            window.location.href = `${
                              process.env.REACT_APP_BASENAME || ""
                            }/DataregisterOld`;
                          } else {
                            window.location.href = `${
                              process.env.REACT_APP_BASENAME || ""
                            }/Dataregister`;
                          }
                        }
                      });
                  } else {
                    window.location.href =
                      admission + "/student_creckregister?ic=" + studentok[0]["ID_LOGIN"];
                  }
                }
                  });
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "มหาวิทยาลัยฯ จะประกาศรายชื่อผู้ผ่านการคัดเลือก",
                text: "ภายในวันที่ 3 พฤษภาคม 2568 เวลา 18.00 น. ",
              });
            }
          } else {
            Swal.fire({
              icon: "info",
              html: "<div><div style='font-size:18px;font-weight:700;'>อยู่ระหว่างการประมวลผลผู้ผ่านการคัดเลือกหลักสูตรผู้ช่วยพยาบาล</div></div>",
            });
          }
        } else {
          if (citizent === "1100200331318") {
            Swal.fire({
              icon: "warning",
              title: "กำลังปรับปรุงระบบ",
            });
          } else {
            this.setState({ status: studentok.length });
            Swal.fire({
              icon: "info",
              title: "ไม่พบข้อมูลของ : " + citizent,
            });
          }
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "ไม่สามารถตรวจสอบได้ในขณะนี้",
          text: "กรุณาลองใหม่อีกครั้ง",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const canSubmit = this.state.citizent.trim().length > 0 && !this.state.loading;

    return (
      <>
        <MetaTags>
          <title>ตรวจสอบสถานะ / ชำระเงินค่าสมัคร | มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ตรวจสอบสถานะการสมัครและชำระเงินค่าสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร"
          />
          <meta property="og:title" content="ตรวจสอบสถานะ / ชำระเงินค่าสมัคร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>

        <div className="check-page">
          <div className="check-shell">
            <div className="check-hero">
              <p className="check-hero__eyebrow">มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
              <h1 className="check-hero__title">
                <BsCardChecklist size={28} aria-hidden />
                {this.state.titlename} / ชำระเงินค่าสมัคร
              </h1>
              <p className="check-hero__desc">
                กรอกเลขบัตรประชาชนหรือ Passport ที่ใช้สมัคร เพื่อดูสถานะและดำเนินการชำระเงิน
              </p>
            </div>

            <div className="check-panel">
              <form className="check-form" onSubmit={this.handleSubmit}>
                <div className="check-field">
                  <label className="check-field__label" htmlFor="citizent">
                    รหัสเลขบัตรประชาชน / Passport
                  </label>
                  <p className="check-field__hint">
                    คนไทยใช้เลข 13 หลัก · ต่างชาติใช้เลข Passport ตามที่ลงทะเบียนไว้
                  </p>
                  <input
                    type="text"
                    className="check-field__input"
                    id="citizent"
                    name="citizent"
                    placeholder="เช่น 1-2345-67890-12-3"
                    value={this.state.citizent}
                    onChange={this.handleChange}
                    autoComplete="off"
                    inputMode="text"
                    required
                  />
                </div>

                <button type="submit" className="check-submit" disabled={!canSubmit}>
                  <AiOutlineFileSearch size={20} aria-hidden />
                  {this.state.loading ? "กำลังตรวจสอบ..." : "ตรวจสอบสถานะ"}
                </button>
              </form>
            </div>

            <div className="check-tips">
              <p className="check-tips__title">หลังตรวจสอบสถานะ คุณสามารถ</p>
              <ul className="check-tips__list">
                <li>
                  <HiOutlineClipboardDocumentList size={16} aria-hidden />
                  ดูสถานะการสมัครและขั้นตอนถัดไป
                </li>
                <li>
                  <BsCreditCard size={16} aria-hidden />
                  พิมพ์ใบแจ้งชำระเงิน หรือชำระเงินค่าสมัครออนไลน์
                </li>
                <li>
                  <BsPrinter size={16} aria-hidden />
                  พิมพ์ใบสมัคร / เอกสารที่เกี่ยวข้องตามรอบที่สมัคร
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}
